module.exports = __webpack_public_path__ + "static/media/health12.a4869e31.svg";